import { useBasisForm } from "basis";
import { Error } from "components/Error/Error";
import { EnhancedAccount } from "library/accounts/types";
import { FullPersonalDetails } from "pages/ManagePersonalDetails/types";
import { Reducer, useReducer } from "react";
import { ExpiredOtp } from "./ExpiredOtp";
import { HomeWorkNumberForm } from "./HomeWorkNumberForm";
import { initialState, reducer } from "./reducer";
import { Success } from "./Success";
import { Actions, PhoneNumbersFormValues, State, Status } from "./types";

type Props = {
  account: EnhancedAccount;
  fullPersonalDetails: FullPersonalDetails;
};

export const UpdateHomeWorkNumber = ({
  account,
  fullPersonalDetails,
}: Props) => {
  const [state, dispatch] = useReducer<Reducer<State, Actions>>(
    reducer,
    initialState,
  );

  const { methods } = useBasisForm<PhoneNumbersFormValues>();
  const { getValues } = methods;
  const number = getValues("number");

  switch (state?.status) {
    case Status.SUCCESS: {
      return <Success phone={`0${number}`} />;
    }

    case Status.ERROR: {
      return <Error />;
    }

    case Status.EXPIRED_OTP: {
      return (
        <ExpiredOtp
          dispatch={dispatch}
          token={state.token}
          createSessionUrl={state.createSessionUrl}
        />
      );
    }

    default: {
      return (
        <HomeWorkNumberForm
          account={account}
          fullPersonalDetails={fullPersonalDetails}
          dispatch={dispatch}
          methods={methods}
        />
      );
    }
  }
};
